module.exports = __webpack_public_path__ + "img/1-1.05ac3dc4.png";